const setFromDate = (fromDate) => {
  return async (dispatch, getState) => {
    let fromDateTyped;
    try {
      fromDateTyped = typeof fromDate === "string" ? new Date(fromDate) : fromDate;
      if (isNaN(fromDateTyped.valueOf())) {
        return;
      }
    } catch (e) {
      return;
    }
    const { toDate } = getState().filterState;
    const dateOffset = (24*60*60*1000) * 7; //7 days
    let toDateValue = toDate.valueOf();
    if (typeof fromDateTyped === "number" || fromDateTyped.valueOf() < new Date("2000-01-01").valueOf()) {
      return;
    }
    const fromDateValue = fromDateTyped.valueOf();
    console.log
    if (toDateValue - fromDateValue > dateOffset || toDateValue <= fromDateValue) {
      toDateValue = fromDateValue + (24*60*60*1000) * 3; //3 days
    }

    dispatch({
      type: "SET_FILTER",
      payload: {
        fromDate: fromDateValue,
        toDate: toDateValue,
        filter: "none",
      },
    });
  }
};

const selected24h = () => {
  let toDate = new Date();
  const dateOffset = (24*60*60*1000) * 1; //1 days
  return {
    type: "SET_FILTER",
    payload: {
      fromDate: toDate.valueOf() - dateOffset,
      toDate: toDate.valueOf(),
      filter: "option2",
    },
  };
};

const selected1weed = () => {
  let toDate = new Date();
  const dateOffset = (24*60*60*1000) * 7; //1 days
  return {
    type: "SET_FILTER",
    payload: {
      fromDate: toDate.valueOf() - dateOffset,
      toDate: toDate.valueOf(),
      filter: "option4",
    },
  };
};

const setToDate = (toDate) => {
  return async (dispatch, getState) => {
    const { fromDate } = getState().filterState;
    let fromDateValue = fromDate.valueOf();
    const toDateTyped = typeof toDate === "string" ? new Date(toDate) : toDate;
    if (isNaN(toDateTyped.valueOf())) {
      return;
    }
    const toDateValue = toDateTyped.valueOf();
    const dateOffset = (24*60*60*1000) * 7; //7 days

    if (toDateValue - fromDateValue > dateOffset || toDateValue <= fromDateValue) {
      fromDateValue = toDateValue - (24*60*60*1000) * 3;
    }
    dispatch({
        type: "SET_FILTER",
        payload: {
          toDate: toDateValue,
          fromDate: fromDateValue,
          filter: "none",
        },
      });
  };
};

const toggleFilters = () => {
  return async (dispatch, getState) => {
    let { filterOpen } = getState().filterState;
    dispatch({
      type: "SET_FILTER",
      payload: {
        filterOpen: !filterOpen,
      },
    });
  };
};

const toggleDetailedValues = () => {
  return (dispatch, getState) => {
    let { showDetailedValues } = getState().filterState;
    dispatch({
      type: "SET_FILTER",
      payload: {
        showDetailedValues: !showDetailedValues,
      },
    });
  };
};

const toggleSensorFilter = (sensor) => {
  return {
      type: "TOGGLE_SENSOR_FILTER",
      sensor,
  };
};

export const FilterAction = {
  setFromDate,
  setToDate,
  toggleDetailedValues,
  selected1weed,
  selected24h,
  toggleFilters,
  toggleSensorFilter,
};
